import { render, staticRenderFns } from "./index.vue?vue&type=template&id=402b271a&scoped=true&"
import script from "./cardManga?vue&type=script&lang=js&"
export * from "./cardManga?vue&type=script&lang=js&"
import style0 from "./cardManga.scss?vue&type=style&index=0&id=402b271a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b271a",
  null
  
)

export default component.exports